export function getCoursesTotalActions(params) {
  return {
    type: "GET_COURSES_TOTAL_ACTIONS",
    payload: {
      params,
    },
  };
}

export function getCoursesTotalActionsSuccess(params) {
  return {
    type: "GET_COURSES_TOTAL_ACTIONS_SUCCESS",
    payload: {
      params,
    },
  };
}

export function getCoursesTotalActionsFail(params) {
  return {
    type: "GET_COURSES_TOTAL_ACTIONS_FAIL",
    payload: {
      params,
    },
  };
}

export function getCourseAnalytics({
  courseId = "",
  eventId = "",
  lessonId = "",
  year = "",
  startDate = "",
  endDate = "",
  page = "",
  perPage = "",
  sortBy = "",
  sortDirection = "",
}) {
  return {
    type: "GET_COURSE_ANALYTICS",
    payload: {
      courseId,
      eventId,
      lessonId,
      year,
      startDate,
      endDate,
      page,
      perPage,
      sortBy,
      sortDirection,
    },
  };
}

export function getCourseAnalyticsSuccess({
  courseAnalytics,
  total,
  pageInfo,
  profileCounts,
  languageCounts,
}) {
  return {
    type: "GET_COURSE_ANALYTICS_SUCCESS",
    payload: {
      courseAnalytics,
      total,
      pageInfo,
      profileCounts,
      languageCounts,
    },
  };
}

export function getCourseAnalyticsFail(params) {
  return {
    type: "GET_COURSE_ANALYTICS_FAIL",
    payload: {
      params,
    },
  };
}

export function getBannersTotalActions(params) {
  return {
    type: "GET_BANNERS_TOTAL_ACTIONS",
    payload: {
      params,
    },
  };
}

export function getBannersTotalActionsSuccess(params) {
  return {
    type: "GET_BANNERS_TOTAL_ACTIONS_SUCCESS",
    payload: {
      params,
    },
  };
}

export function getBannersTotalActionsFail(params) {
  return {
    type: "GET_BANNERS_TOTAL_ACTIONS_FAIL",
    payload: {
      params,
    },
  };
}

export function getBannerAnalytics({
  eventId = "",
  bannerId = "",
  year = "",
  startDate = "",
  endDate = "",
  page = "",
  perPage = "",
  sortBy = "",
  sortDirection = "",
}) {
  return {
    type: "GET_BANNER_ANALYTICS",
    payload: {
      eventId,
      bannerId,
      year,
      startDate,
      endDate,
      page,
      perPage,
      sortBy,
      sortDirection,
    },
  };
}

export function getBannerAnalyticsSuccess({
  bannerAnalytics,
  total,
  pageInfo,
  profileCounts,
  languageCounts,
}) {
  return {
    type: "GET_BANNER_ANALYTICS_SUCCESS",
    payload: {
      bannerAnalytics,
      total,
      pageInfo,
      profileCounts,
      languageCounts,
    },
  };
}

export function getBannerAnalyticsFail(params) {
  return {
    type: "GET_BANNER_ANALYTICS_FAIL",
    payload: {
      params,
    },
  };
}

export function clearCourseAnalytics() {
  return {
    type: "CLEAR_COURSE_ANALYTICS",
  };
}

export function clearBannerAnalytics() {
  return {
    type: "CLEAR_BANNER_ANALYTICS",
  };
}

export function getEventList() {
  return {
    type: "GET_EVENT_LIST_ANALYTICS",
  };
}

export function getEventListSuccess({ events, years, eventsInfo }) {
  return {
    type: "GET_EVENT_LIST_ANALYTICS_SUCCESS",
    payload: { events, years, eventsInfo },
  };
}

export function getEventListFailure(error) {
  return {
    type: "GET_EVENT_LIST_ANALYTICS_FAILURE",
    payload: error,
  };
}

export function getCoursesByEventId({ eventId }) {
  return {
    type: "GET_COURSES_ANALYTICS",
    payload: { eventId },
  };
}

export function getCoursesSuccessByEventId({ courses }) {
  return {
    type: "GET_COURSES_ANALYTICS_SUCCESS",
    payload: {
      courses,
    },
  };
}

export function getCoursesFailureByEventId(error) {
  return {
    type: "GET_COURSES_ANALYTICS_FAILURE",
    payload: error,
  };
}

export function getLessonsByCourseId({ courseId }) {
  return {
    type: "GET_LESSONS_ANALYTICS",
    payload: { courseId },
  };
}

export function getLessonsSuccessByCourseId({ lessons }) {
  return {
    type: "GET_LESSONS_ANALYTICS_SUCCESS",
    payload: {
      lessons,
    },
  };
}

export function getLessonsFailureByCourseId(error) {
  return {
    type: "GET_LESSONS_ANALYTICS_FAILURE",
    payload: error,
  };
}

export function getBannersByEventId({ eventId }) {
  return {
    type: "GET_BANNERS_LIST",
    payload: { eventId },
  };
}

export function getBannersSuccessByEventId({ banners }) {
  return {
    type: "GET_BANNERS_LIST_SUCCESS",
    payload: {
      banners,
    },
  };
}

export function getBannersFailureByEventId(error) {
  return {
    type: "GET_BANNERS_LIST_FAILURE",
    payload: error,
  };
}
